import React, { useState, useEffect } from 'react';

import AdminAccountFile from '../program/AccountFile';

export default function AccountFile() {
	return (
		<>
		<AdminAccountFile admin={true}/>
		</>
	)
}
